import React from 'react';

const BlockAlert = ({ title, text, type }) => {
  return (
    <div className={`block-alert block-alert-${type}`}>
      <p className="block-alert-title">{title}</p>
      {text && <p className="block-alert-text">{text}</p>}
    </div>
  );
};

export default BlockAlert;
